import React, { useEffect, useState, useRef } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { useIsMobile } from "../services/UseIsMobile";
import '../css/pieMorphing.css';

const COLORS = ['#6F3F89', '#375A9C', '#029FB2', '#29A648', '#E0B614', '#DA5E20', '#C11D24'];

function lerp(a, b, t) {
  return a + (b - a) * t;
}

const PieMorphing = ({ targetAnswers, targetScoring }) => {
  
    const getImageForScore = (score) => {
    if (score <= -40) return "/Images/result0.png";
    else if (score <= -20) return "/Images/result1.png";
    else if (score <= 0) return "/Images/result2.png";
    else if (score <= 20) return "/Images/result3.png";
    else if (score <= 40) return "/Images/result4.png";
    return "/Images/result5.png";
  };
    const [answers, setAnswers] = useState(targetAnswers);
    // eslint-disable-next-line no-unused-vars
    const [scoringValue, setScoringValue] = useState(targetScoring);
    const [prevImage, setPrevImage] = useState(getImageForScore(scoringValue));
    const [nextImage, setNextImage] = useState(null);
    const [fadeIn, setFadeIn] = useState(false);
    const fadeTimeoutRef = useRef(null);

    const durationImageFade = 500;
    const durationImage = 1000;

    const sectionAngle = 360.0 / 7.0;
    const initialOffset = 90.0 + (sectionAngle / 2.0);

    useEffect(() => {
        const images = [
            "/Images/result0.png",
            "/Images/result1.png",
            "/Images/result2.png",
            "/Images/result3.png",
            "/Images/result4.png",
            "/Images/result5.png"
        ];
        images.forEach(src => {
            const img = new Image();
            img.src = src;
        });
        }, []);

    // interpolation progressive quand les props changent
    useEffect(() => {
      const steps = 30;
      const interval = durationImage / steps;
      let frame = 0;

      const startValues = answers; // état actuel
      const anim = setInterval(() => {
        frame++;
        setAnswers(() =>
          startValues.map((val, idx) =>
            lerp(val, targetAnswers[idx], frame / steps)
          )
        );
        if (frame >= steps) clearInterval(anim);
      }, interval);

      return () => clearInterval(anim);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [targetAnswers]);

    useEffect(() => {
        const newImage = getImageForScore(targetScoring);

        if (newImage === prevImage) return;

        // Si fade en cours, attendre la fin avant de changer
        if (fadeTimeoutRef.current) {
            clearTimeout(fadeTimeoutRef.current);
            fadeTimeoutRef.current = null;
        }

        setNextImage(newImage);
        setFadeIn(false);

        requestAnimationFrame(() => setFadeIn(true));

        fadeTimeoutRef.current = setTimeout(() => {
            setPrevImage(newImage);
            setNextImage(null);
            setFadeIn(false);
            fadeTimeoutRef.current = null;
        }, durationImageFade);

        return () => {
            if (fadeTimeoutRef.current) {
            clearTimeout(fadeTimeoutRef.current);
            fadeTimeoutRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [targetScoring]);

    const getScaleForValue = (value) => {
        const minScale = 1;
        const maxScale = 1.5;
        const minValue = 1;
        const maxValue = 10;
        return minScale + (value - minValue) * ((maxScale - minScale) / (maxValue - minValue));
    };

    const isMobile = useIsMobile(768);
    const innerRadius = isMobile ? 40 : 65;
    const outerRadius = isMobile ? 70 : 100;
    const imgSize = isMobile ? 80 : 128;

  return (
    <div className="pie-morphing-container">
        <div className="pie-morphing-responsive" 
        style={{
          transform: `rotate(-${initialOffset}deg)`, // Rotation dans le sens antihoraire
        }}>
            <div className="responsive-wrapper">
                <ResponsiveContainer width="100%" height="100%">
            <PieChart animationDuration={0}>
              <Pie
                data={answers.map((v, i) => ({ name: `Part ${i + 1}`, value: Math.abs(v) })).reverse()}
                cx="50%"
                cy="50%"
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                paddingAngle={5}
                dataKey="value"
                isAnimationActive={true}
                animationDuration={1000}
              >
                {answers
                  .slice()        
                  .reverse()     
                  .map((val, index) => {
                  const scale = getScaleForValue(val);
                  return (
                    <Cell
                      className="recharts-cell"
                      key={`cell-${index}`}
                      fill={COLORS[index]}
                      style={{
                        transform: `scale(${scale})`,
                        transformOrigin: "center",
                        transition: "transform 0.05s linear",
                      }}
                    />
                  );
                })}
              </Pie>
            </PieChart>
                </ResponsiveContainer>
            </div>
        </div>

        <div className="centered-result-text">
            <img
                src={prevImage}
                alt="Previous Scoring"
                style={{
                    width: `${imgSize}px`,
                    height: `${imgSize}px`,
                }}
            />
            {nextImage && (
            <img
                src={nextImage}
                alt="Next Scoring"
                style={{
                    width: `${imgSize}px`,
                    height: `${imgSize}px`,
                    opacity: fadeIn ? 1 : 0,
                    transition: "opacity 0.5s ease-in-out",
                }}
            />
            )}
        </div>
    </div>
  );
};

export default PieMorphing;